import { Prize } from "./prize";

export enum GiveawayType {
	monthly = "monthly",
	weekly = "weekly",
}

export interface Promotion {
	id: number;
	type: GiveawayType;
	startDate: Date;
	endDate: Date;
	winnerId: number;
	status: string;
	createdAt: Date;
	updatedAt: Date;
	prizeId: number;
	prize: Prize;
	entryCount?: number;
	totalEntries?: number;
}
